import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import FinancingTerms from './FinancingTerms/FinancingTerms';
import { FINANCING_TERMS_PATH } from './routes/routePaths';

export default function Routes() {
  return (
    <>
      <Switch>
        <Route exact path={FINANCING_TERMS_PATH} component={FinancingTerms} />
        <Redirect to={FINANCING_TERMS_PATH} />
      </Switch>
    </>
  );
}
